const bodyFontComponents = ['Paragraph', 'SizableText', 'Text', 'Label'];
const headingFontComponents = ['Heading', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

export const fontDefaults = {
  ...bodyFontComponents.reduce(
    (obj, comp) => ({ ...obj, [comp]: { fontFamily: '$body', color: '$bodyFont' } }),
    {}
  ),
  ...headingFontComponents.reduce(
    (obj, comp) => ({ ...obj, [comp]: { fontFamily: '$heading', color: '$headingFont' } }),
    {}
  )
};
